module.exports = __webpack_public_path__ + "img/cloth_g3_hat-10.424e91f4.svg";